import classNames from 'classnames';

import { sortAssignments } from '../../utils';
import { Accordion } from '../Body/Accordion';
import { CategoryRow } from '../Body/CategoryRow';
import { PointOrGradeToggleButton } from '../Body/PointOrGradeToggleButton';
import { HeaderCell } from '../Body/TableCells';
import { SearchBar } from '../SearchBar/SearchBar';
import s from './ISGBody.module.css';

const HEADERS = [
  'Assignment name',
  'Score',
  'Due Date',
  'Completed',
  'Time Spent',
];

export const ISGBody = ({
  currentStudent,
  throttledSearchChange,
  searchPhrase,
  resetSearch,
  handleSearchFocus,
  settings,
  studentId,
  categoriesData,
  sortBy,
  sortOrder,
  user,
  handleSortClick,
  getLaunchUrl,
  handleLocalLaunch,
  getStudentReportLink,
  hasStudentReport,
  isMobile,
  showPercent,
  isDropdownOpen,
  isChat = false,
}) => {
  return (
    <div
      className={classNames({
        [s.mobileBody]: isMobile,
        [s.dialogBody]: !isMobile,
        [s.dialogBodyChat]: isChat,
      })}
      data-test-id={isMobile ? `isg-mobile-body` : `isg-modal-body`}
    >
      <div className={s.bodyHeader}>
        <div className={s.leftGroup}>
          <SearchBar
            searchTerm={searchPhrase}
            onChange={throttledSearchChange}
            onReset={resetSearch}
            onFocus={handleSearchFocus}
            placeholder="Search Assignments"
          />
          {!isMobile && <PointOrGradeToggleButton />}
        </div>
      </div>
      <div className={s.accordions}>
        {categoriesData.map((categoryData) => {
          const { assignments, unfilteredAssignments, total } = categoryData;
          if (!unfilteredAssignments?.length) {
            return null;
          }

          const sortedAssignments = sortAssignments(
            sortBy,
            sortOrder,
            assignments,
          );

          return (
            <Accordion key={categoryData.name} categoryData={categoryData}>
              <div className={isMobile ? s.mobileTable : s.table}>
                {!isMobile && (
                  <div className={s.tableRow}>
                    {HEADERS.map((header) => (
                      <HeaderCell
                        key={header}
                        label={header}
                        sortBy={sortBy}
                        sortOrder={sortOrder}
                        onClick={handleSortClick}
                      />
                    ))}
                  </div>
                )}
                {sortedAssignments?.map((assignment) => {
                  if (!assignment.isAssigned) return null;
                  return (
                    <CategoryRow
                      isChat={isChat}
                      isMobile={isMobile}
                      key={assignment?.id}
                      assignment={assignment}
                      settings={settings}
                      user={user}
                      studentId={studentId}
                      getLaunchUrl={getLaunchUrl}
                      handleLocalLaunch={handleLocalLaunch}
                      getStudentReportLink={getStudentReportLink}
                      hasStudentReport={hasStudentReport}
                      showPercent={showPercent}
                      currentStudent={currentStudent}
                      isDropdownOpen={isDropdownOpen}
                    />
                  );
                })}
                {total && (
                  <CategoryRow
                    isChat={isChat}
                    assignment={total}
                    settings={settings}
                    user={user}
                    isTotal={true}
                    studentId={studentId}
                    isMobile={isMobile}
                    showPercent={showPercent}
                    currentStudent={currentStudent}
                    isDropdownOpen={isDropdownOpen}
                    categoryName={categoryData.name}
                  />
                )}
              </div>
            </Accordion>
          );
        })}
      </div>
    </div>
  );
};
